import React from 'react';
import { Button } from 'components/Buttons';
import { FormikProps } from 'formik';
import * as Styled from './ContactRepModalView.styles';
import { ContactRepFormState, Form } from './Form';
import { Option } from '../../types';

interface FormComponentProps {
  representativesList: Option[];
  isFormSentInProgress: boolean;
  handleCancel: () => void;
  handleSendMessage: () => void;
  onSubmitForm: (values: ContactRepFormState) => Promise<void>;
  formRef: React.RefObject<FormikProps<ContactRepFormState>>;
}

export const FormComponent: React.FC<FormComponentProps> = ({
  representativesList,
  isFormSentInProgress,
  handleCancel,
  handleSendMessage,
  onSubmitForm,
  formRef,
}) => {
  return (
    <>
      <Styled.ContactRepModalHeader variant="body">
        Select all that apply and a Brand Rep will be in touch.
      </Styled.ContactRepModalHeader>
      <Form
        representatives={representativesList}
        defaultSelectedRepresentative={representativesList[0]}
        onSubmit={onSubmitForm}
        isFormSentInProgress={isFormSentInProgress}
        ref={formRef}
      />
      <Styled.ContactRepModalFooter>
        <Button
          variant="contained"
          color="secondary"
          size="medium"
          onClick={handleCancel}
          disabled={isFormSentInProgress}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="medium"
          onClick={handleSendMessage}
          disabled={isFormSentInProgress}
        >
          {isFormSentInProgress ? 'Sending...' : 'Send'}
        </Button>
      </Styled.ContactRepModalFooter>
    </>
  );
};
